<template>
<div>
  <nav class="navbar navbar-expand-lg text-dark bg-white fixed-top">
    <router-link to="/" class="navbar-brand">
        <img
            :src="logo"
            alt="logo"
            class="logo-responsive"
            style="max-height: 40px; max-width: 200px;"
            v-if="logo && logo != '?'"
        />
        <span v-else>
            Portal
        </span>
    </router-link>

    <!-- Portal do Apoiado -->
    <template v-if="$store.state.user.st_tipo == 'O'">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <template v-if="is_teste">
                <router-link class="nav-link" to="/apoio">
                    Início
                </router-link>
            </template>
            <router-link class="nav-link" to="/apoiocadastro" v-if="$store.state.user.model && $store.state.user.model.fl_cad_portal">
                Cadastro
            </router-link>
            <router-link class="nav-link" to="/apoioresultados">
                    Pedidos
            </router-link>
            <template v-if="$store.state.user.model && ( $store.state.user.model.st_tipo_acesso == 'S' || $store.state.user.model.st_tipo_acesso == 'P' || $store.state.user.model.st_tipo_acesso == 'T' || $store.state.user.model.fl_portal_download )">
                <router-link class="nav-link" to="/portaldownload">
                    Download de Resultados
                </router-link>
            </template>
            <template v-if="1==0 && $store.state.user.model && $store.state.user.model.portal_consultas && $store.state.user.model.portal_consultas.length">
                <router-link class="nav-link" to="/portalinfo">
                    Informações/Resultados
                </router-link>
            </template>
            <template v-if="false">
                <router-link class="nav-link" to="/apoioamostras">
                    Amostras
                </router-link>
                <router-link class="nav-link" to="/apoiohelp">
                    Help de Exames
                </router-link>
                <router-link class="nav-link" to="/apoioinfo">
                    Informações
                </router-link>
            </template>
            <template v-if="$store.state.user && $store.state.user.abas && $store.state.user.abas.length">
                <router-link class="nav-link" :to="'/pa/' + aba.id_apoiado_portal_aba" v-for="(aba, iix) in $store.state.user.abas" :key="iix">
                    {{ aba.search }}
                </router-link>
            </template>

            <template>
                <router-link class="nav-link" to="/apoiorelats" v-if="$store.state.user.tem_relat">
                    Relatórios
                </router-link>
            </template>
        </div>
    </template>

    <template v-else-if="$store.state.user.st_tipo == 'R'">
        <router-link class="nav-link" to="/">
            Resultados
        </router-link>  
        <template v-if="$store.state.user && $store.state.user.abas && $store.state.user.abas.length">
            <router-link class="nav-link" :to="'/pa/' + aba.id_apoiado_portal_aba" v-for="(aba, iix) in $store.state.user.abas" :key="iix">
                {{ aba.search }}
            </router-link>
        </template>
    </template>

    <template v-else>
      <router-link class="nav-link" to="/" v-if="$store.state.unidade.agendas && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
        Agendar
      </router-link>
      <router-link class="nav-link" to="/resultados" v-if="$store.state.user.st_tipo != 'X' && $store.state.user.st_tipo != 'R' && $store.state.unidade.resultados">
        Resultados
      </router-link>
      <router-link class="nav-link" to="/" v-if="$store.state.user.st_tipo == 'O'">
        Lançamento
      </router-link>
      <template v-if="$store.state.user && $store.state.user.abas && $store.state.user.abas.length">
        <router-link class="nav-link" :to="'/pa/' + aba.id_apoiado_portal_aba" v-for="(aba, iix) in $store.state.user.abas" :key="iix">
            {{ aba.search }}
        </router-link>
      </template>
      <a :href="link_ajuda" target="_blank" class="nav-link" v-if="link_ajuda && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
        <i class="fa-solid fa-circle-question"></i>
      </a>
    </template>

    <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="1==0">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">
              Agendar
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.unidade.resultados">
            <router-link class="nav-link" to="/resultados">
              Resultados
            </router-link>
          </li>
          <li class="nav-item" v-if="link_ajuda">
            <a :href="link_ajuda" target="_blank" class="nav-link">
              Ajuda
            </a>
          </li>
          
        </ul>
    </div>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>
    

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      
      <!-- Menu do Usu[ario -->
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a id="navbarDropdown" class="nav-link active dropdown-toggle d-flex flex-row align-items-center"
            href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div :data-initials="$store.state.user.initials" data-toggle="tooltip" data-placement="left" 
              :title="$store.state.user.search + ' (' + $store.state.user.st_login + ')'"></div>
            <div class="caret"></div>
          </a>

          <div id="creek-dropdown" class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a class="dropdown-item ddip-card" href="#" @click="verMeusDados ()" v-if="$store.state.user.pessoa && $store.state.user.pessoa.paciente_unidade">Meus Dados</a>
            <a class="dropdown-item ddip-card" href="#" @click="logout ()">Sair</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>

  <!-- Modal -->
  <div class="modal fade" id="meusDadosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Meus Dados</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
          <portal-meus-dados ref="meusdados" :marcacao="meus_dados" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          <az-submit @click="atualizar_cadastro()">Atualizar</az-submit>
        </div>
      </div>
    </div>
  </div>

</div>
  
</template>

<script>
import $ from 'jquery';
import PortalMeusDados from './PortalMeusDados.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
  props: ['link_ajuda'],

  components: {
    PortalMeusDados,
    AzSubmit,
  },

  computed: { 
    is_teste: function () { 
      return window.redir == 'teste';
    },

    meus_dados: function () { 
      return { 
        paciente: this.$store.state.user.pessoa, 
      };
    },

    logo: function() { 
        return this.$store.state.logo;
    }
  },

  methods: {
    atualizar_cadastro () { 
      this.$refs.meusdados.atualizar();
    },

    verMeusDados () { 
      $('#meusDadosModal').modal('show');
    },

    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },

    logout() {
      //this.$store.commit("setUser", null);
      window.location = "/";
    }
  },
  updated () { 
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>

/* Initials */

[data-initials]:before {
background: black;
color: white;
opacity: 1; 
content: attr(data-initials); 
display: inline-block; 
font-weight: bold; 
border-radius: 50%; 
vertical-align: middle; 
margin-right: 0.5em; 
width: 30px; 
height: 30px; 
line-height: 30px; 
text-align: center; 
}

</style>